/**
 * Guarda o token de verificação entre o `signup-id` e o `signup-password`.
 *
 * A confirmação de e-mail e celular acontece nos steps do `signup-id`, mas quem
 * cria a conta é o `signup()` do `signup-password`, uma navegação depois — e o
 * Auth0 só devolve os identificadores conhecidos em `screen.data`, não um campo
 * nosso. O `sessionStorage` é do mesmo domínio e morre com a aba, que é
 * exatamente o tempo de vida do cadastro.
 */

const KEY = 'alelo_signup_verification_token'

type Stored = { token: string; exp: number }

/** `exp` do payload (segundos), para não devolver um token que já venceu. */
function expirationOf(token: string): number {
  const payload = token.split('.')[1]
  if (!payload) return 0
  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const parsed = JSON.parse(json) as { exp?: number }
    return typeof parsed.exp === 'number' ? parsed.exp : 0
  } catch {
    return 0
  }
}

export function save(token: string): void {
  const exp = expirationOf(token)
  if (!exp) return
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, exp } satisfies Stored))
  } catch {
    // Storage indisponível: o cadastro cai no caminho de verificação da senha.
  }
}

/**
 * Devolve o token guardado e o apaga — uso único do lado do cliente também.
 * Token vencido é descartado: a tela de senha refaz a verificação.
 */
export function take(nowMs: number = Date.now()): string | null {
  let raw: string | null = null
  try {
    raw = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
  } catch {
    return null
  }
  if (!raw) return null

  try {
    const stored = JSON.parse(raw) as Stored
    if (!stored.token || stored.exp * 1000 <= nowMs) return null
    return stored.token
  } catch {
    return null
  }
}

export function clear(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nada a fazer
  }
}
